/**
 * Converts a numeric amount to Indian Rupee Words format
 * e.g., 501 -> "Five Hundred and One Rupees Only"
 *       10001 -> "Ten Thousand and One Rupees Only"
 */
export function amountToWordsIndian(amount) {
  const num = Math.floor(Number(amount) || 0);
  if (num === 0) return "Zero Rupees Only";

  const singleDigits = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  function convertUnderThousand(n) {
    let s = "";
    if (n >= 100) {
      s += singleDigits[Math.floor(n / 100)] + " Hundred";
      n %= 100;
      if (n > 0) s += " and ";
    }
    if (n > 0) {
      if (n < 20) {
        s += singleDigits[n];
      } else {
        s += tens[Math.floor(n / 10)];
        if (n % 10 > 0) s += " " + singleDigits[n % 10];
      }
    }
    return s.trim();
  }

  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const remainder = num % 1000;

  const parts = [];
  if (crore > 0) parts.push(convertUnderThousand(crore) + " Crore");
  if (lakh > 0) parts.push(convertUnderThousand(lakh) + " Lakh");
  if (thousand > 0) parts.push(convertUnderThousand(thousand) + " Thousand");
  if (remainder > 0) {
    const underThousand = convertUnderThousand(remainder);
    if (parts.length > 0 && remainder < 100) {
      parts.push("and " + underThousand);
    } else {
      parts.push(underThousand);
    }
  }

  return parts.join(" ") + " Rupees Only";
}
